<template>
  <el-container class="index-con">
    <el-container class="main-con">
      <!-- 顶部导航栏 -->
      <div id="topMenu" class="top-menu shadow-sm fixed-top" style="background-color: white;">
        <div class="menu-container">
          <div class="logo-container">
            <img src="../../../static/不空.jpg" alt="不空素材网" class="logo-img">
          </div>

          <!-- 桌面版导航菜单 -->
          <div class="nav-menu d-none d-md-flex">
            <el-menu class="el-menu-demo" mode="horizontal">
              <el-menu-item index="1" @click="$router.push('/userlist')">用户管理</el-menu-item>
              <el-menu-item index="2" @click="$router.push('/rwgllist')">人物管理</el-menu-item>
              <el-menu-item index="3" @click="$router.push('/bjgllist')">背景管理</el-menu-item>
              <el-menu-item index="4" @click="$router.push('/djgllist')">道具管理</el-menu-item>
              <el-menu-item index="5" @click="$router.push('/bqgllist')">表情管理</el-menu-item>
              <el-menu-item index="6" @click="$router.push('/txgllist')">特效管理</el-menu-item>
              <el-menu-item index="7" @click="$router.push('/yxgllist')">音效管理</el-menu-item>
              <el-menu-item index="8" @click="$router.push('/bgmgllist')">BGM管理</el-menu-item>
<!--              <el-menu-item index="9" @click="$router.push('/spgllist')">视频管理</el-menu-item>-->
              <el-menu-item index="10" @click="$router.push('/rjgllist')">软件管理</el-menu-item>
              <el-menu-item index="11" @click="$router.push('/cjzc')">插件注册</el-menu-item>
            </el-menu>
          </div>

          <!-- 移动端菜单按钮 -->
          <div class="mobile-menu-btn d-md-none">
            <el-button icon="el-icon-menu" @click="drawer = true"></el-button>
          </div>

          <!-- 用户操作区域 -->
          <div class="user-actions">
            <el-button type="text" :hidden="this.$store.state.btnLoginHiddenAdmin"
                       @click="$store.state.showLoginDialogAdmin=true">登 录
            </el-button>

            <el-dropdown @command="btnUser" :hidden="this.$store.state.loginUserHiddenAdmin">
              <span class="el-dropdown-link">
                不空<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="updatepwd">修改密码</el-dropdown-item>
                <el-dropdown-item command="exit">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

      <!-- 移动端抽屉菜单 -->
      <el-drawer
        title="菜单导航"
        :visible.sync="drawer"
        direction="rtl"
        size="80%">
        <el-menu @select="drawer = false">
          <el-menu-item index="1" @click="$router.push('/userlist')">用户管理</el-menu-item>
          <el-menu-item index="2" @click="$router.push('/rwgllist')">人物管理</el-menu-item>
          <el-menu-item index="3" @click="$router.push('/bjgllist')">背景管理</el-menu-item>
          <el-menu-item index="4" @click="$router.push('/djgllist')">道具管理</el-menu-item>
          <el-menu-item index="5" @click="$router.push('/bqgllist')">表情管理</el-menu-item>
          <el-menu-item index="6" @click="$router.push('/txgllist')">特效管理</el-menu-item>
          <el-menu-item index="7" @click="$router.push('/yxgllist')">音效管理</el-menu-item>
          <el-menu-item index="8" @click="$router.push('/bgmgllist')">BGM管理</el-menu-item>
<!--          <el-menu-item index="9" @click="$router.push('/spgllist')">视频管理</el-menu-item>-->
          <el-menu-item index="10" @click="$router.push('/rjgllist')">软件管理</el-menu-item>
          <el-menu-item index="11" @click="$router.push('/cjzc')">插件注册</el-menu-item>
        </el-menu>
      </el-drawer>

      <!-- 登录对话框 -->
      <el-dialog title="不空素材网" width="90%" :modal="false"
                 :visible.sync="$store.state.showLoginDialogAdmin"
                 custom-class="login-dialog">
        <el-form :model="form">
          <el-form-item label="账 号" :label-width="formLabelWidth">
            <el-input v-model="form.account" autocomplete="off" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密 码" :label-width="formLabelWidth">
            <el-input v-model="form.password" autocomplete="off" placeholder="请输入密码" show-password></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="btnLogin">确 定</el-button>
          <el-button @click="$store.state.showLoginDialogAdmin = false">取 消</el-button>
        </div>
      </el-dialog>

      <!-- 主要内容区域 -->
      <el-main class="index-main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import {login} from '../../api/bkUser'
import {setStore, getStore, removeStore} from '../../utils/util'

export default {
  name: 'index',
  data() {
    return {
      form: {
        account: '',
        password: ''
      },
      formLabelWidth: '120px',
      drawer: false // 控制移动端菜单抽屉
    }
  },
  created() {
    var id = getStore("idAdmin", id);
    var account = getStore("accountAdmin", account);
    var token = getStore("tokenAdmin", token);

    if (id !== "" && id !== null && token !== "" && token !== null && account !== "" && account !== null) {
      this.form.account = account;
      this.$store.state.showLoginDialogAdmin = false;
      this.$store.state.loginUserHiddenAdmin = false;
      this.$store.state.btnLoginHiddenAdmin = true;
    } else {
      this.$store.state.showLoginDialogAdmin = true;
      this.$store.state.loginUserHiddenAdmin = true;
      this.$store.state.btnLoginHiddenAdmin = false;
    }
  },
  methods: {
    btnUser(ac) {
      if (ac === "exit") {
        removeStore("idAdmin");
        removeStore("accountAdmin");
        removeStore("tokenAdmin");

        this.$store.state.loginUserHiddenAdmin = true;
        this.$store.state.btnLoginHiddenAdmin = false;
      }
    },
    btnLogin() {
      let account = this.form.account;
      let pwd = this.form.password;
      login({account: account, pwd: pwd}).then((res) => {
        if (res.State === 1) {
          var token = res.Data.AccessToken;
          var id = res.Data.id;
          var account = res.Data.account;
          setStore("idAdmin", id);
          setStore("accountAdmin", account);
          setStore("tokenAdmin", token);

          this.$store.state.showLoginDialogAdmin = false;
          this.$store.state.loginUserHiddenAdmin = false;
          this.$store.state.btnLoginHiddenAdmin = true;
        } else {
          this.$message.error(res.ErrorMessage);
        }
      });
    }
  }
}
</script>

<style scoped>
/* 基础布局 */
.index-con {
  min-height: 100vh;
  width: 100%;
}

.main-con {
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏样式 */
.top-menu {
  width: 100%;
  height: 60px;
  z-index: 1000;
}

.menu-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 5%;
  max-width: 1400px;
  margin: 0 auto;
}

.logo-container {
  flex-shrink: 0;
}

.logo-img {
  height: 50px;
  width: auto;
  max-width: 120px;
  object-fit: contain;
}

.nav-menu {
  flex: 1;
  overflow-x: auto;
  padding: 0 20px;
}

.user-actions {
  flex-shrink: 0;
  margin-left: 20px;
}

/* 主要内容区域 */
.index-main {
  padding: 20px;
  margin-top: 60px;
  flex: 1;
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .menu-container {
    padding: 0 15px;
  }

  .nav-menu {
    display: none !important;
  }

  .mobile-menu-btn {
    display: block !important;
    margin-left: auto;
    margin-right: 15px;
  }

  .index-main {
    padding: 15px;
  }
}

/* 登录对话框响应式 */
@media (max-width: 576px) {
  .login-dialog {
    width: 95% !important;
  }

  .el-form-item__label {
    width: 80px !important;
  }

  .el-input {
    width: 100% !important;
  }
}

/* 全局样式调整 */
.el-menu--horizontal {
  border-bottom: none;
}

.el-menu-item {
  padding: 0 12px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-drawer__header {
  margin-bottom: 0;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.el-drawer__body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/htgl/index.vue